import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "product-item" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-minus" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field field-select" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "store" }, "Type", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "price" }, "Price", -1)
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, "Date", -1)
const _hoisted_15 = ["textContent"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

import Choice, { Item } from '@/components/choice/Choice.vue';
import Product from '@/models/product.model';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: {
  index: {
    type: Number,
    required: true,
  },
  product: {
    type: Object as PropType<any>,
    required: true,
  },
  types: {
    type: Array as PropType<Item[]>,
    required: true,
  },
},
  emits: ['removeItem'],
  setup(__props, { emit }) {

const props = __props;





const removeItem = () => {
  emit('removeItem', props.index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "name",
        name: "name",
        autofocus: "",
        autocomplete: "off",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.product.name) = $event))
      }, null, 512), [
        [_vModelText, props.product.name]
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: removeItem,
        class: "remove-button icon-only"
      }, _hoisted_5),
      (!props.product.isValid('name'))
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "field-validation",
            textContent: _toDisplayString(props.product.validation.messages.name)
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(Choice, {
        modelValue: props.product.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.product.type) = $event)),
        id: "type",
        items: props.types
      }, null, 8, ["modelValue", "items"]),
      (!props.product.isValid('store'))
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "field-validation",
            textContent: _toDisplayString(props.product.validation.messages.store)
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "price",
        placeholder: "0.00",
        lang: "en-US",
        step: "0.01",
        id: "price",
        name: "price",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.product.price) = $event))
      }, null, 512), [
        [
          _vModelText,
          props.product.price,
          void 0,
          { number: true }
        ]
      ]),
      (!props.product.isValid('price'))
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "field-validation",
            textContent: _toDisplayString(props.product.validation.messages.price)
          }, null, 8, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _withDirectives(_createElementVNode("input", {
        type: "date",
        class: "date",
        id: "date",
        name: "date",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.product.date) = $event))
      }, null, 512), [
        [_vModelText, props.product.date]
      ]),
      (!props.product.isValid('date'))
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "field-validation",
            textContent: _toDisplayString(props.product.validation.messages.date)
          }, null, 8, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _hoisted_16
  ]))
}
}

})